export default __webpack_public_path__ + "static/media/help.36b60f76.svg";